import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';
import { ChevronLeft, Menu } from 'lucide-react';

const Header = ({ title, showBack = true, showMenu = false, rightContent = null, className = '', onMenuClick }) => {
  const navigate = useNavigate();
  const { toggleSidebar } = useAppContext();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <header className={`header strict-width header-fixed ${className}`}>
      <div className="header-content">
        <div className="left-content">
          {showBack && (
            <button onClick={handleBack} className="dz-floating-toggler">
              <ChevronLeft size={32} />
            </button>
          )}
          {
            showMenu &&
              // <button onClick={onMenuClick} className="icon dz-floating-toggler">
              {
                /* className="menu-toggler"> */
              }
            //   <span></span>
            //   <span></span>
            //   <span></span>
            // </button>
          }
        </div>
        <div className="mid-content">
          <h4 className="title">{title}</h4>
        </div>
        <div className="right-content d-flex align-items-center gap-4">
          {rightContent || (
            <button onClick={toggleSidebar} className="icon dz-floating-toggler">
              <Menu size={32} />
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
